<template>
	<ext-dialog
		v-model="value"
		:title="$t('containers')"
		:primaryButtonText="null"
		:secondaryButtonText="null"
		dialogType="large"
		@closed="onDialogClosed"
	>
		<template #body>
			<v-card-text v-if="containerItems.length === 0">
				{{ $t("no_entity", { entityName: $t("containers") }) }}
			</v-card-text>

			<common-table
				v-else
				class="pb-6 pt-6"
				:headers="productContainerListHeaders"
				:items="containerItems"
				:hide-pagination="true"
				:entity-name="$t('containers')"
			>
				<template #item.code="{ item }">
					<span class="primary--text underlined" @click="selectContainer(item.container)">
						{{ item.code }}
					</span>
				</template>

				<template #item.quantity="{ item }"> {{ item.quantity }} {{ item.unitCode }} </template>

				<template #item.price="{ item }">
					{{ formatCurrency(item.price) }}
				</template>

				<template #item.total_amount="{ item }">
					<div class="d-flex justify-end">
						{{ formatCurrency(item.total_amount) }}
					</div>
				</template>
			</common-table>
		</template>
	</ext-dialog>
</template>

<script>
import ExtDialog from "../../../partials/dialogs/ExtDialog.vue";
import CommonTable from "../../../partials/CommonTable.vue";

export default {
	name: "ProductContainersDialog",
	components: { ExtDialog, CommonTable },
	props: {
		value: Boolean,
		product: {
			type: Object,
			default: null,
		},
		shipment: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			productContainerListHeaders: [
				{ text: this.$t("$shortening.number"), value: "code", sortable: false },
				{ text: this.$t("name"), value: "name", sortable: false },
				{ text: this.$t("quantity"), value: "quantity", sortable: false },
				{ text: this.$t("amount"), value: "price", sortable: false },
				{ text: this.$t("total_amount"), value: "total_amount", sortable: false },
			],
		};
	},
	computed: {
		filteredContainers() {
			if (!this.product || !this.shipment?.containers) return [];
			return this.shipment.containers.filter((container) =>
				(container.products || []).some(
					(p) =>
						this.resolveName(p) === this.product.name &&
						Number(p.amount) === Number(this.product.amount) &&
						p.unitCode === this.product.unitCode
				)
			);
		},
		containerItems() {
			return this.filteredContainers.map((container) => {
				const cp = (container.products || []).find(
					(p) =>
						this.resolveName(p) === this.product.name &&
						Number(p.amount) === Number(this.product.amount) &&
						p.unitCode === this.product.unitCode
				);
				return {
					container,
					code: container.code,
					name: this.product.name,
					quantity: cp ? cp.quantity : 0,
					price: cp ? cp.amount : 0,
					unitCode: cp ? cp.unitCode : "",
					total_amount: cp ? cp.quantity * cp.amount : 0,
				};
			});
		},
	},

	methods: {
		resolveName(p) {
			const fromLocale = p.name?.[this.$i18n.locale];
			const anyName = Object.values(p.name || {}).find((v) => v);
			return fromLocale ?? p.name?._default ?? p.displayName ?? anyName ?? "Unnamed";
		},
		selectContainer(container) {
			this.$emit("select-container", container);
			this.$emit("input", false);
		},
		onDialogClosed() {
			this.$emit("input", false);
		},
		formatCurrency(value) {
			if (!this.shipment || !this.shipment.currency) return value;
			return value.toLocaleString(this.$lang, { style: "currency", currency: this.shipment.currency.code });
		},
	},
};
</script>

<style scoped>
.primary--text.underlined {
	cursor: pointer;
	text-decoration: underline;
}
</style>
